// extracted by css-extract-rspack-plugin
export default {"loginPageRoot":"ZQnnuu","input":"gOLu60","signUpWrapper":"meUbp7"};